<div class="opening-instructions-banner mb-2">
  <div class="opening-instructions-card" role="alert">
    <div class="opening-instructions-card-header">
      <div class="d-flex align-items-start gap-2 flex-grow-1 min-w-0">
        <span class="opening-instructions-icon-wrap">
          <i data-feather="info" class="text-white"></i>
        </span>

        <div class="opening-instructions-content flex-grow-1 min-w-0">
          <span class="opening-instructions-title d-block">{{ title }}</span>

          <p class="opening-instructions-text mb-0">{{ instructions }}</p>

          <div class="opening-instructions-footer" *ngIf="dismissible && canHidePreference">
            <button
              type="button"
              class="btn opening-instructions-dismiss-btn"
              [disabled]="isSavingPreference"
              (click)="onDontShowAgain()"
            >
              Não mostrar novamente
            </button>
          </div>
        </div>
      </div>

      <button
        *ngIf="dismissible"
        type="button"
        class="btn btn-icon btn-flat btn-sm opening-instructions-close"
        aria-label="Fechar"
        (click)="onClose()"
      >
        <i data-feather="x"></i>
      </button>
    </div>

    <div class="opening-instructions-progress-wrap" *ngIf="dismissible">
      <ngb-progressbar
        type="info"
        [value]="progressValue"
        height="5px"
        class="opening-instructions-progress"
      ></ngb-progressbar>
    </div>
  </div>
</div>
